import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import React from "react";
var __jsx = React.createElement;
import PublicSlot from "components/slot/PublicSlot";
import { useRouter } from "next/router";
import styled from "styled-components";
import dynamic from "next/dynamic";
import Head from "next/head";
var StartEarningRewardsSectionElement = dynamic(function () {
  return import("components/ScreenComponent/StartEarningRewards/StartEarningRewardsSection");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("components/ScreenComponent/StartEarningRewards/StartEarningRewardsSection")];
    }
  }
});
var Root = styled.div.withConfig({
  displayName: "slotId__Root",
  componentId: "sc-1ozqaik-0"
})(["padding:48px;display:flex;flex-direction:column;align-items:center;"]);
var Slot = function Slot(_ref) {
  var slot = _ref.slot;
  var router = useRouter();
  return router.isFallback ? __jsx(React.Fragment, null, "Loading...") : __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, "WRewards - Slot ", slot.title)), __jsx(Root, null, __jsx(PublicSlot, {
    slot: slot
  }), __jsx(StartEarningRewardsSectionElement, {
    showRelevant: true
  })));
};
export var __N_SSG = true;
export default _withSuperJSONPage(Slot);